import { MouseEventHandler } from 'react';
import useTranslation from '@components/Translation/useTranslation';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@repo/ui/src/components/Icons/CloseIcon';
import { classNames } from '@repo/ui/src/utils/classNames';

interface Props {
  open: boolean;
  onClose: MouseEventHandler<HTMLButtonElement>;
  children: any;
  dark?: boolean;
  TransitionProps?: any;
  hideClose?: boolean;
}

const FullscreenDialog = ({
  open,
  onClose,
  children,
  dark,
  TransitionProps = {},
  hideClose = false,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Dialog
      onClose={onClose}
      open={open}
      maxWidth={false}
      fullScreen
      className={dark ? 'dark-mode' : ''}
      TransitionProps={TransitionProps}
      classes={{
        root: 'tw-bg-none',
        paper: dark ? '!tw-bg-[#25282af2]' : '!tw-bg-surface-400',
      }}
      PaperProps={{ role: 'dialog', 'aria-modal': true }}
    >
      <DialogContent className="tw-p-0 tw-relative tw-flex tw-flex-col">
        <div className="tw-flex tw-justify-end tw-sticky tw-top-0">
          {!hideClose && (
            <button
              aria-label={t('genericContent.closeIconButtonLabel', undefined, { default: 'close' })}
              onClick={onClose}
              className={classNames(
                'tw-text-surface-700 tw-p-2 sm:tw-p-3 md:tw-p-4 tw-bg-surface-400 tw-border-r-0 hover:tw-bg-surface-400 focus-visible:tw-outline-2 focus-visible:tw-outline-action-500',
                dark && 'tw-text-white tw-bg-surface-800 hover:tw-bg-primary-300',
              )}
            >
              <CloseIcon />
            </button>
          )}
        </div>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default FullscreenDialog;
